import BaseModel from './BaseModel'

export default class PaymentTracking extends BaseModel {
  // ... PaymentTracking-specific methods or overrides ...
}
